/**
 * Created by Federico Brocco on 07/12/2023.
 *
 * @format
 */

/**
 * Recupera l'elenco dei tipi di leggi disponibili
 * @returns {Promise<Array>} Promise che risolve con un array di tipi di leggi
 */
let list = function () {
    return new Promise(function (resolve, reject) {

        fetch(window.route.lawsType, {
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API laws list', responseJson);
                resolve(responseJson.law_types);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

/**
 * Recupera i dettagli delle leggi per un tipo specifico
 * @param {string|number} law_type_id - L'ID del tipo di legge
 * @returns {Promise<Array>} Promise che risolve con un array di leggi per il tipo specificato
 */
let detail = function (law_type_id) {
    return new Promise(function (resolve, reject) {

        fetch(window.route.lawsDetail + "?law_type_id=" + law_type_id, {
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API law detail', responseJson);
                resolve(responseJson.laws);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};



const LawsAPI = {
    list: list,
    detail: detail
};

export default LawsAPI;
